<div
  #searchBar
  class="search-bar"
  [class.show-results]="isSearchResultVisible$ | async">
  <coin-v2-text-input
    #searchInputElement
    placeholder="{{ placeholder | translate }}"
    icon="search"
    size="medium"
    name="search"
    id="search"
    autocomplete="off"
    [clearable]="!!searchInput"
    [(ngModel)]="searchInput" />
</div>

<div
  #searchResults
  class="results"
  [class.show]="(isSearchResultVisible$ | async) ? 1 : 0">
  <div class="scroll-container">
    <coin-group-search-results
      [resultCacheKey]="resultCacheKey"
      [searchResultGroups]="searchResultGroups"
      [searchString]="searchInput"
      [isCosmos]="isCosmos"
      (initializeSearchLambda)="initializeSearchLambda.emit()"
      (navigatedToResult)="onNavigatedToResult()"></coin-group-search-results>
  </div>
</div>
